import OneSignalVuePlugin from "onesignal-vue";
import OneSignalNativePlugin from "@tt-app/utils/notifications/nativePlugin";

const derivedInstall = (() => {
  if ((window as any).OneSignal) {
    return OneSignalNativePlugin.install;
  }

  return OneSignalVuePlugin.install;
})();

const OneSignalWrapperPlugin = {
  install: derivedInstall
};

export default OneSignalWrapperPlugin;
